import { Box, Typography } from '@mui/material';
import VerticalContainer from '../../common/VerticalContainer';
import { useResponsive } from '../../../contexts/ResponsiveContext';
import { useLocale } from '../../../contexts/LocaleProvider';
import { formatIcuString } from '../../../utils/Locale';

import { useKsimData } from './ysim/useYsimData';
import DatasetToggles from './ysim/DatasetToggles';
import KsimLineChart from './ysim/KsimLineChart';
import type { KsimPlotProps } from './ysim/types';

export default function KsimPlot({ partNumber, contentTree }: KsimPlotProps) {
    const { responsiveWidth } = useResponsive();
    const { locale: pimCoreLocale } = useLocale();

    const { state, toggleDataset } = useKsimData(partNumber);
    const { allDatasets, plotData, selectedDatasets, loading, error } = state;

    if (loading) return <></>;

    if (error) {
        return (
            <VerticalContainer sx={{ backgroundColor: '#F2F2F2' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <p>
                        {formatIcuString(
                            contentTree.ksim.noSimulationDataAvailable.content,
                            { partNumber },
                            pimCoreLocale
                        )}
                    </p>
                </Box>
            </VerticalContainer>
        );
    }

    return (
        <VerticalContainer
            containerName="ysim"
            sx={{ backgroundColor: '#F2F2F2', alignItems: 'center' }}
        >
            <Box sx={{ width: '100%', textAlign: 'center', margin: '0 auto' }}>
                <Typography
                    sx={{
                        color: '#B75332',
                        fontFamily: 'Poppins',
                        fontWeight: 700,
                        fontSize: '1.5rem',
                    }}
                >
                    {formatIcuString(
                        contentTree.ksim.typicalElectricalPerformance.content,
                        { partNumber },
                        pimCoreLocale
                    )}
                </Typography>
            </Box>

            {/* 勾選器 */}
            <Box
                sx={{
                    width: responsiveWidth,
                    margin: '0 auto 16px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
                data-testid="ysim-options"
            >
                <DatasetToggles
                    datasets={allDatasets}
                    selected={selectedDatasets}
                    onToggle={toggleDataset}
                />
            </Box>

            {/* Chart */}
            <Box
                sx={{
                    width: responsiveWidth,
                    height: '500px',
                    margin: '0 auto',
                    display: 'flex',
                    justifyContent: 'center',
                }}
                data-testid="ysim-plot"
            >
                <KsimLineChart
                    plotDatasets={plotData}
                    allDatasets={allDatasets}
                    selectedLabels={selectedDatasets}
                />
            </Box>
        </VerticalContainer>
    );
}
